import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyHerdDetails, getDairyHerdDetailsAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, FOOTPRINTING_DAIRY_HERD_DETAILS } from "consts";

import { FootprintingDairyHerdDetails } from "models";

export const useGetFootprintingDairyHerdDetails = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery<FootprintingDairyHerdDetails>(
    {
      queryKey: [FOOTPRINTING_DAIRY_HERD_DETAILS, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getDairyHerdDetailsAdmin(primaryDataId) : getDairyHerdDetails(primaryDataId)),
      enabled: options?.enabled !== false && !!primaryDataId,
      gcTime: DEFAULT_CACHE_TIME,
      staleTime: DEFAULT_CACHE_TIME,
    },
    queryClient
  );
};
